import { Australia } from "@faire/icons/flags/Australia";
import { Austria } from "@faire/icons/flags/Austria";
import { Belgium } from "@faire/icons/flags/Belgium";
import { Bulgaria } from "@faire/icons/flags/Bulgaria";
import { Canada } from "@faire/icons/flags/Canada";
import { Croatia } from "@faire/icons/flags/Croatia";
import { Cyprus } from "@faire/icons/flags/Cyprus";
import { Czechia } from "@faire/icons/flags/Czechia";
import { Denmark } from "@faire/icons/flags/Denmark";
import { Estonia } from "@faire/icons/flags/Estonia";
import { Finland } from "@faire/icons/flags/Finland";
import { France } from "@faire/icons/flags/France";
import { Germany } from "@faire/icons/flags/Germany";
import { Greece } from "@faire/icons/flags/Greece";
import { Hungary } from "@faire/icons/flags/Hungary";
import { Ireland } from "@faire/icons/flags/Ireland";
import { Italy } from "@faire/icons/flags/Italy";
import { Japan } from "@faire/icons/flags/Japan";
import { Korea } from "@faire/icons/flags/Korea";
import { Latvia } from "@faire/icons/flags/Latvia";
import { Lithuania } from "@faire/icons/flags/Lithuania";
import { Luxembourg } from "@faire/icons/flags/Luxembourg";
import { Malta } from "@faire/icons/flags/Malta";
import { Netherlands } from "@faire/icons/flags/Netherlands";
import { NewZealand } from "@faire/icons/flags/NewZealand";
import { Norway } from "@faire/icons/flags/Norway";
import { Poland } from "@faire/icons/flags/Poland";
import { Portugal } from "@faire/icons/flags/Portugal";
import { Romania } from "@faire/icons/flags/Romania";
import { Slovakia } from "@faire/icons/flags/Slovakia";
import { Slovenia } from "@faire/icons/flags/Slovenia";
import { Spain } from "@faire/icons/flags/Spain";
import { Sweden } from "@faire/icons/flags/Sweden";
import { Switzerland } from "@faire/icons/flags/Switzerland";
import { UnitedKingdom } from "@faire/icons/flags/UnitedKingdom";
import { UnitedStates } from "@faire/icons/flags/UnitedStates";
import { SVGIconComponent } from "@faire/slate/icons/types";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";

// Maintain in alphabetical order based on ISO3166Alpha3 for better readability
export const ISO_COUNTRY_TO_FLAG_ICON: Partial<
  Record<keyof typeof ISO3166Alpha3, SVGIconComponent>
> = {
  [ISO3166Alpha3.AUS]: Australia,
  [ISO3166Alpha3.AUT]: Austria,
  [ISO3166Alpha3.BEL]: Belgium,
  [ISO3166Alpha3.BGR]: Bulgaria,
  [ISO3166Alpha3.CAN]: Canada,
  [ISO3166Alpha3.CHE]: Switzerland,
  [ISO3166Alpha3.CYP]: Cyprus,
  [ISO3166Alpha3.CZE]: Czechia,
  [ISO3166Alpha3.DEU]: Germany,
  [ISO3166Alpha3.DNK]: Denmark,
  [ISO3166Alpha3.ESP]: Spain,
  [ISO3166Alpha3.EST]: Estonia,
  [ISO3166Alpha3.FIN]: Finland,
  [ISO3166Alpha3.FRA]: France,
  [ISO3166Alpha3.GBR]: UnitedKingdom,
  [ISO3166Alpha3.GRC]: Greece,
  [ISO3166Alpha3.HRV]: Croatia,
  [ISO3166Alpha3.HUN]: Hungary,
  [ISO3166Alpha3.IRL]: Ireland,
  [ISO3166Alpha3.ITA]: Italy,
  [ISO3166Alpha3.JPN]: Japan,
  [ISO3166Alpha3.KOR]: Korea,
  [ISO3166Alpha3.LTU]: Lithuania,
  [ISO3166Alpha3.LUX]: Luxembourg,
  [ISO3166Alpha3.LVA]: Latvia,
  [ISO3166Alpha3.MLT]: Malta,
  [ISO3166Alpha3.NLD]: Netherlands,
  [ISO3166Alpha3.NOR]: Norway,
  [ISO3166Alpha3.NZL]: NewZealand,
  [ISO3166Alpha3.POL]: Poland,
  [ISO3166Alpha3.PRT]: Portugal,
  [ISO3166Alpha3.ROU]: Romania,
  [ISO3166Alpha3.SVK]: Slovakia,
  [ISO3166Alpha3.SVN]: Slovenia,
  [ISO3166Alpha3.SWE]: Sweden,
  [ISO3166Alpha3.USA]: UnitedStates,
};
